import usePersistedArray from '../../hooks/usePersistedArray';
export const useSearchHistory = function (key) {
  let initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let maxItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  const {
    data,
    addData,
    filterData,
    filteredData
  } = usePersistedArray(key, initial, maxItems, false);
  return {
    history: data,
    addHistory: addData,
    filteredHistory: filteredData,
    filterHistory: filterData
  };
};